"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
var Logs_1 = require("../models/Logs");
exports.InventoryAPI = {
    getInventory: function (companyId, locationId, filter) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, index_1.axios.get("/api/v1/company/" + companyId + "/location/" + locationId + "/inventory", {
                        params: filter,
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data.inventory];
            }
        });
    }); },
    getInventoryList: function (companyId, locationId, filter) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, index_1.axios.get("/api/v1/company/" + companyId + "/location/" + locationId + "/inventory/list?" + filter.queryString)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data.inventoryList];
            }
        });
    }); },
    getBasicInventory: function (companyId, locationId, filter) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, index_1.axios.get("/api/v1/company/" + companyId + "/location/" + locationId + "/inventory/basic", {
                        params: filter,
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data.data];
            }
        });
    }); },
    getInventoryByProduct: function (companyId, productId) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, index_1.axios.get("/api/v1/company/" + companyId + "/product/" + productId + "/inventories")];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data.inventories];
            }
        });
    }); },
    getInventoryByMultipleLocations: function (companyId, searchFilters) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, index_1.axios.get("/api/v1/company/" + companyId + "/inventory", {
                        params: searchFilters,
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
    updateBulkInventory: function (companyId, locationId, bulkInventory) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, index_1.axios.put("/api/v1/company/" + companyId + "/location/" + locationId + "/inventory/bulk", bulkInventory)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
    getNegativeInventoryProductList: function (companyId, locationIds) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, index_1.axios.get("/api/v1/company/" + companyId + "/inventory/negativeQuantityInventory", {
                        params: {
                            locationIds: locationIds,
                        },
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
    updateProductStockAlertLevels: function (companyId, locationId, productId, inventoryStockLevelUpdateContract) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, index_1.axios.patch("/api/v1/company/" + companyId + "/location/" + locationId + "/inventory/" + productId + "/stockAlertLevels", inventoryStockLevelUpdateContract)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
    bulkUpdateStockAlertLevels: function (companyId, locationId, inventoryStockLevelBulkUpdateContract) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, index_1.axios.put("/api/v1/company/" + companyId + "/location/" + locationId + "/inventory/stockAlertLevels", inventoryStockLevelBulkUpdateContract)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); },
    getInventoryLogs: function (companyId, limit, offset, filter) {
        if (limit === void 0) { limit = 30; }
        if (offset === void 0) { offset = 0; }
        return __awaiter(_this, void 0, void 0, function () {
            var inventoryLogFilter, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        inventoryLogFilter = new Logs_1.InventoryLogFilter(limit, offset, filter);
                        return [4 /*yield*/, index_1.axios.get("/api/v1/company/" + companyId + "/eventLogs/inventory?" + inventoryLogFilter.queryString)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    },
};
//# sourceMappingURL=InventoryAPI.js.map